import { Box, Container } from "@mui/material";

function Header({
  screenWidth,
  handleOpenOfficialWebsite,
  handleOpenBespokeForm,
}) {
  return (
    <>
      {screenWidth === "Small" ? (
        <Container maxWidth="md">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/InvestINBannerLogo.png`}
              alt="InvestIN Banner Logo"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          </Box>
        </Container>
      ) : (
        <div class="w3-display-container w3-animate-opacity">
          <img
            //src={`${process.env.PUBLIC_URL}/InvestINBannerLogo.png`}
            src={
              "https://media.licdn.com/dms/image/v2/C4D1BAQFfSGiz0Rf-Ow/company-background_10000/company-background_10000/0/1629385576959/investin_cover?e=2147483647&v=beta&t=TFD75WPwhzNKP0Y-eeN1yoYOyyxqYfaiwDfWRpp-SwU"
            }
            alt="InvestIN Banner Logo"
            style={{
              width: "100%",
              minHeight: "350px",
              maxHeight: "550px",
            }}
          />
        </div>
      )}
    </>
  );
}

export default Header;
